// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"16":"database","388":"result","430":"newsEdit","847":"resource","946":"news"}[chunkId] || chunkId) + "." + {"16":"75a56a0b","214":"c786e6d0","388":"74555708","430":"03b8d296","847":"36aa9ec2","946":"1bd27c09"}[chunkId] + ".css";
};